export function publicProfileUrl(username) {
  return `${window.location.origin}/u/${encodeURIComponent(username)}`
}

export function publicProfileTracksUrl(username) {
  return `${publicProfileUrl(username)}/tracks`
}

export function publicProfileTripsUrl(username) {
  return `${publicProfileUrl(username)}/trips`
}
